import type { Product } from '@@partner:types:app'
import type { GQL_ID } from '@@partner:types:graphql'

import React, { useState, useEffect } from 'react'
import { formatXid } from '@@partner:helpers/util'
import { getMinAmount, stockAmount } from '@@partner:helpers/product'
import { useCurrentCart } from '../../cart/CartContext'

import ProductCardControls from '../ProductCardControls'
import ProductPriceSale from '../ProductPriceSale'
import ProductCardPrice from '../ProductCardPrice'
import ProductPackageInfo from '../ProductPackageInfo'

import { NO_PHOTO_IMAGE } from '@@partner:config/image'

import './ProductSearchItem.scss'

export interface ProductSearchItemProps {
  product: Product
  onProductChoose: (id: GQL_ID, amount: number) => void
  // onDeleteProduct?: (id: GQL_ID) => void
}

export default function ProductSearchItem ({
  product,
  onProductChoose
}: ProductSearchItemProps) {
  const { currentShopCart } = useCurrentCart()
  const productInCart =
    currentShopCart?.products?.find((p) => p.id === product.id) ?? null

  const [ amount, setAmount ] = useState(productInCart?.amount ?? 0)

  useEffect(() => {
    if (productInCart) {
      setAmount(productInCart.amount)
    }
  }, [ productInCart ])

  const productPreviewUrl = product?.preview?.url ?? NO_PHOTO_IMAGE
  const step = getMinAmount(product)
  const maxAmount: number = stockAmount(product, 0) as number

  const handleProductAmountChange = (amount: number) => {
    setAmount(amount)
    onProductChoose(product.id, amount)
  }

  return (
    <div className="ProductSearchItem">
      <div className="ProductSearchItem__preview">
        <ProductPriceSale product={product} />
        <img src={productPreviewUrl} alt={product.name} />
      </div>

      <div className="ProductSearchItem__name">
        {product.name} <strong>({formatXid(product.xid)})</strong>
        <ProductPackageInfo product={product} />
        <div className="ProductSearchItem__price">
          <ProductCardPrice price={product.price} oldPrice={product.oldPrice} />
        </div>
        <div className="ProductSearchItem__stockinfo">
          {maxAmount > 0 ? (
            <div className="ProductSearchCard__Body__Amount">
              <strong>В наличии: </strong>
              {maxAmount}
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>

      <div className="ProductSearchItem__controls">
        <ProductCardControls
          amountStep={step}
          amount={amount || 0}
          onAmountChange={handleProductAmountChange}
        />
      </div>
    </div>
  )
}
